import { createAsyncThunk } from '@reduxjs/toolkit'

import { GREEDY_LINE_BREAK_REGEX } from '../../constants/utility-constants'
import { AppDispatch, RootState } from '../../reducers'
import currentPlaySlice from '../../reducers/currentPlaySlice'
import { selectCurrentTrackSlug } from '../../selectors/current-play-selectors'
import player from '../../services/TrackMixer'
import { updateLocalTrack } from './update-local-track'

const loadLocalTimingFromString = createAsyncThunk<
  { wordCount: number; timedWordCount: number },
  { asReference: boolean; timingString: string },
  { state: RootState; dispatch: AppDispatch }
>('load/loadLocalTimingFromString', ({ asReference, timingString }, { dispatch, getState }) => {
  const gamer = player.defaultGamer
  if (!gamer) {
    console.warn('no default gamer')
    return { wordCount: 0, timedWordCount: 0 }
  }
  const trackSlug = selectCurrentTrackSlug(getState())
  const lrcLines = timingString.split(GREEDY_LINE_BREAK_REGEX)
  dispatch(currentPlaySlice.actions.setLRClines(lrcLines))

  if (asReference) {
    dispatch(currentPlaySlice.actions.setIsPlayable(true)) // TODO: criteria?
  }
  dispatch(currentPlaySlice.actions.setIsScoreDirty(true))
  gamer.importLRC({ asReference, lrcLines, isLoad: true, isReplaceLyrics: true })
  const { wordCount, timedWordCount } = gamer
  dispatch(updateLocalTrack({ trackSlug, audioData: { timedWordCount, wordCount } }))
  return { wordCount, timedWordCount }
})

export default loadLocalTimingFromString
